import { EmailProvider } from 'src/types/models/EmailProvider';
import { UserTier } from 'src/types/models/UserTier';
import { PROJECT_NAME, TIER_TITLE_MAP } from 'src/constants';

export const isGoogleEmailProvider = (
  emailProvider: EmailProvider | string | undefined | null,
) =>
  emailProvider === EmailProvider.GOOGLE ||
  emailProvider === EmailProvider.GOOGLE_WORKSPACE;

/** @deprecated Use value from hook useGetUser */
export const isOpenTier = (tier_id?: UserTier | null) => {
  return tier_id === UserTier.OPEN || !tier_id;
};

/** @deprecated Use value from hook useGetUser */
export const isProTier = (tier_id?: UserTier | null) => {
  return (
    tier_id === UserTier.PRO ||
    tier_id === UserTier.PAID ||
    tier_id === UserTier.TESTING
  );
};

/** @deprecated Use value from hook useGetUser */
export const isLimitedTier = (tier_id?: UserTier | null) => {
  return (
    tier_id === UserTier.STANDARD ||
    tier_id === UserTier.FREE ||
    tier_id === UserTier.OPEN ||
    tier_id === UserTier.TEAMS_STANDARD
  );
};

/** @deprecated Use value from hook useGetUser */
export const isSubscribedTier = (tier_id?: UserTier | null) => {
  return (
    tier_id === UserTier.PAID ||
    tier_id === UserTier.STANDARD ||
    tier_id === UserTier.PRO ||
    tier_id === UserTier.ULTRA ||
    tier_id === UserTier.TESTING ||
    tier_id === UserTier.ENTERPRISE ||
    tier_id === UserTier.TEAMS_STANDARD ||
    tier_id === UserTier.TEAMS_PRO ||
    tier_id === UserTier.TEAMS_ULTRA ||
    tier_id === UserTier.ENTERPRISE_TRIAL ||
    tier_id === UserTier.SUPERNINJA_ULTRA ||
    tier_id === UserTier.TEAMS_SUPERNINJA_ULTRA ||
    tier_id === UserTier.INTERNAL_UNLIMITED ||
    tier_id === UserTier.SUPERNINJA_STANDARD
  );
};

/** @deprecated Use value from hook useGetUser */
export const isTeamsTier = (tier_id?: UserTier | null) => {
  return (
    tier_id === UserTier.TEAMS_PRO ||
    tier_id === UserTier.TEAMS_ULTRA ||
    tier_id === UserTier.TEAMS_STANDARD ||
    tier_id === UserTier.TEAMS_SUPERNINJA_ULTRA ||
    tier_id === UserTier.BUSINESS_SUPERNINJA_PRO ||
    tier_id === UserTier.BUSINESS_SUPERNINJA_ULTRA ||
    tier_id === UserTier.BUSINESS_SUPERNINJA_MAX
  );
};

export const convertTierName = (name: string) => {
  const newValue = TIER_TITLE_MAP[name as UserTier];
  if (!!newValue) {
    return newValue;
  } else {
    if (name === 'pro' || name === 'standard' || name === 'ultra') {
      return `${PROJECT_NAME} ${name}`;
    }
    return name.startsWith('teams_')
      ? 'Business'
      : name.replace('business_superninja_', 'business_').replace('_', ' ');
  }
};
